import React from 'react';

const ModalWhatsApp = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleWhatsAppClick = () => {
    const whatsappURL = 'https://wa.me/525533326766?text=Hola,%20quiero%20información%20sobre%20TecnoVigilancia%20360';
    window.open(whatsappURL, '_blank');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="modal-body">
          <div className="modal-icon">💬</div>
          <h3 className="modal-title">WhatsApp</h3>
          <p className="modal-text">
            ¿Deseas iniciar conversación por WhatsApp?
          </p>

          <div className="modal-buttons">
            <button className="btn btn-whatsapp" onClick={handleWhatsAppClick}>
              Sí, abrir WhatsApp
            </button>
            <button className="btn btn-cancel" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalWhatsApp;
